import {request} from '../../api/client';
import type {FolderLocation} from './explorerApi';
import {beginFolderClick,folderHelperStatus,isWindows,openHelperEntry} from './folderMode';

export const NATIVE_NETWORK_NOTICE='Нет доступа к локальной сети студии или выбранному файлу. Подключитесь к студийной сети или VPN и проверьте доступ в Проводнике Windows.';
export class NativeEntryError extends Error { constructor(message:string,readonly update=false){super(message);} }

/** Explicit menu action: never reads or changes the task-folder preference. */
export async function openNativeEntry(location:FolderLocation,signal:AbortSignal) {
  if(!isWindows())throw new NativeEntryError('Открытие в Проводнике доступно на компьютере с Windows.');
  let nonce=beginFolderClick();
  const helper=await folderHelperStatus(true);
  if(signal.aborted)return;
  if(helper==='update')throw new NativeEntryError('Для открытия файлов и папок обновите помощник Проводника.',true);
  if(helper!=='ready')throw new NativeEntryError('Запустите помощник папок Скрепки. Если он уже работает, разрешите браузеру доступ к локальной сети.');
  nonce??=beginFolderClick();
  if(!nonce)throw new NativeEntryError('Не удалось запустить помощник Проводника. Повторите нажатие.');
  const {ticket}=await request<{ticket:string}>('/api/explorer/native-entry-ticket',{method:'POST',body:location,signal});
  if(signal.aborted)return;
  const result=await openHelperEntry(ticket,signal,nonce);
  if(signal.aborted)return;
  if(!result)throw new NativeEntryError(NATIVE_NETWORK_NOTICE);
}
